import { render, staticRenderFns } from "./AquaObjectInput.vue?vue&type=template&id=23bb129c&scoped=true&"
import script from "./AquaObjectInput.vue?vue&type=script&lang=js&"
export * from "./AquaObjectInput.vue?vue&type=script&lang=js&"
import style0 from "./AquaObjectInput.vue?vue&type=style&index=0&id=23bb129c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bb129c",
  null
  
)

export default component.exports